/**
 * Created by jordid on 11/05/16.
 * @module tooltip
 */
import 'qtip2';

import { hasTouchEvents } from './common/device';

export function init($container) {
    let $useContainer = $container;
    if (!$useContainer) {
        $useContainer = $('body');
    }

    if (hasTouchEvents()) {
        return;
    }

    $useContainer.find('[data-tooltip]').qtip({
        position: {
            my: 'bottom center',
            at: 'top center',
        },
        style: {
            classes: 'qtip-tipsy',
        },
    });
}
